import type { CSSProperties } from 'react';
import { getRadiusCssValue } from '@/theme/radius';

const MARKDOWN_BLOCK_RADIUS_PX = 26;
const MARKDOWN_BLOCK_BACKGROUND = "rgb(15 19 29 / 58%)";
const MARKDOWN_BLOCK_BORDER = '1px solid rgba(255, 255, 255, 0.05)';
const MARKDOWN_BLOCK_SHADOW = '0 4px 18px -8px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255,255,255,0.02)';

const MARKDOWN_BLOCK_ROOT_BASE_STYLE: CSSProperties = {
  width: '100%',
};

const MARKDOWN_BLOCK_CONTAINER_BASE_STYLE: CSSProperties = {
  width: '100%',
  maxWidth: '100%',
  backgroundColor: MARKDOWN_BLOCK_BACKGROUND,
  borderRadius: getRadiusCssValue(MARKDOWN_BLOCK_RADIUS_PX),
  border: MARKDOWN_BLOCK_BORDER,
  boxShadow: MARKDOWN_BLOCK_SHADOW,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  position: 'relative',
  overflow: 'hidden',
};

export function getMarkdownBlockRootStyle(style?: CSSProperties): CSSProperties {
  if (!style) {
    return MARKDOWN_BLOCK_ROOT_BASE_STYLE;
  }

  return {
    ...MARKDOWN_BLOCK_ROOT_BASE_STYLE,
    ...style,
  };
}

export function getMarkdownBlockContainerStyle(style?: CSSProperties): CSSProperties {
  if (!style) {
    return MARKDOWN_BLOCK_CONTAINER_BASE_STYLE;
  }

  return {
    ...MARKDOWN_BLOCK_CONTAINER_BASE_STYLE,
    ...style,
  };
}
